/* Dabrana · complimentary 8ml tester
   Keeps a real ₹0 tester line in the Shopify cart, in sync with how many bottles are in it.
   Any number of bottles -> exactly 1 tester · empty cart -> none.

   Why a real cart line and not a discount: Shiprocket (Fastrr) checkout reads the Shopify
   cart at handoff. Shopify automatic-discount "free gift" rules do not run inside it, but
   line items do carry across. So the gift must exist as a line before checkout opens.

   To change the rule, edit testersFor() below. */
(function () {
  var GIFT_VARIANT = 53794297151853;      // Complimentary 8ml Tester — Surprise Scent
  var GIFT_TYPE = 'Tester';               // product_type used by all tester products
  var MARK = 'dabgift=1';                 // marks our own requests so we don't loop
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/i;

  function testersFor(bottles) {
    return bottles < 1 ? 0 : 1;
  }

  var busy = false, queued = false, timer = null;

  function json(url, body) {
    var u = url + (url.indexOf('?') > -1 ? '&' : '?') + MARK;
    var opts = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(u, opts).then(function (r) { return r.json(); });
  }

  function sync() {
    if (busy) { queued = true; return Promise.resolve(false); }
    busy = true;
    return json('/cart.js').then(function (cart) {
      var bottles = 0, gift = 0;
      (cart.items || []).forEach(function (it) {
        if (it.variant_id === GIFT_VARIANT) gift += it.quantity;
        else if (it.product_type === GIFT_TYPE) { /* stray tester: neither bottle nor gift */ }
        else bottles += it.quantity;
      });
      var target = testersFor(bottles);
      if (target === gift) return false;
      if (gift === 0) return json('/cart/add.js', { items: [{ id: GIFT_VARIANT, quantity: target }] }).then(yes);
      var updates = {};
      updates[GIFT_VARIANT] = target;
      return json('/cart/update.js', { updates: updates }).then(yes);
    }).catch(function () { return false; }).then(function (changed) {
      busy = false;
      if (queued) { queued = false; return sync(); }
      return changed;
    });
  }
  function yes() { return true; }

  function drawerOpen() {
    var d = document.getElementById('dab-cart');
    return !!(d && d.classList.contains('is-open'));
  }

  function refresh() {
    /* the drawer is the checkout path — never blow it away with a page reload */
    if (drawerOpen()) { if (window.__dabOpenCart) window.__dabOpenCart(); return; }
    if (/^\/cart(\/|$)/.test(location.pathname)) { location.reload(); return; }
    document.dispatchEvent(new CustomEvent('dab:gift:updated'));
  }

  function run() {
    sync().then(function (changed) { if (changed) refresh(); });
  }

  function schedule(url) {
    if (url && url.indexOf(MARK) > -1) return;
    if (url && !CART_RE.test(url)) return;
    clearTimeout(timer);
    timer = setTimeout(run, 150);
  }

  /* react to whatever the theme does to the cart, however it does it */
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var out = origFetch.apply(this, arguments);
      if (out && out.then) out.then(function () { schedule(u); }, function () {});
      return out;
    };
  }
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__dabGiftUrl = u; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    x.addEventListener('load', function () { schedule(x.__dabGiftUrl || ''); });
    return xs.apply(this, arguments);
  };

  /* opening the cart, or coming back to the tab, is a good moment to reconcile */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('a[href^="/cart"],[aria-label="Cart"],[data-cart-open]');
    if (t) schedule('');
  }, true);
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(''); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  /* ---------------------------------------------------------------------------
     Buy Now must end up in Shiprocket, never Shopify's native checkout.

     The theme's Buy Now navigates straight to /checkout. Fastrr (Shiprocket)
     only replaces standard cart checkout buttons, so it never hooks this one.

     Fix: swallow the click, add to cart with the theme's own Add to Cart
     button, then open the slide-in cart DRAWER — whose checkout button Fastrr
     has replaced, so the customer gets the Shiprocket flow. No navigation:
     the customer stays on the product page with the drawer over it.
  --------------------------------------------------------------------------- */
  var SR_HOSTS = '[id*="fastrr"],[class*="fastrr"],[id*="shiprocket"],[class*="shiprocket"],[id*="Fastrr"],[class*="sr-checkout"],[class*="srCheckout"]';

  function label(el) { return ((el.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase()); }

  function isOurBuyNow(el) {
    var t = label(el);
    if (t.indexOf('BUY NOW') !== 0) return false;
    if (t.indexOf('POWERED BY') > -1) return false;   // Shiprocket's own button
    if (el.closest('#dab-cart')) return false;        // never the drawer's checkout button
    return !el.closest(SR_HOSTS);
  }

  function findAddToCart() {
    var all = document.querySelectorAll('button,a,[role="button"]');
    for (var i = 0; i < all.length; i++) {
      if (label(all[i]).indexOf('ADD TO CART') === 0 && !all[i].closest(SR_HOSTS)) return all[i];
    }
    return null;
  }

  function openDrawer() {
    if (window.__dabOpenCart) { window.__dabOpenCart(); return; }
    /* drawer script missing: fall back to the cart page rather than dead-ending */
    location.href = '/cart';
  }

  function countThenOpen(before, tries) {
    if (tries > 12) { openDrawer(); return; }
    json('/cart.js').then(function (c) {
      if (c && c.item_count > before) openDrawer();
      else setTimeout(function () { countThenOpen(before, tries + 1); }, 200);
    }).catch(function () { openDrawer(); });
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('button,a,[role="button"]') : null;
    if (!el || !isOurBuyNow(el)) return;
    var atc = findAddToCart();
    if (!atc) return;                       // nothing to add: leave the click alone
    e.preventDefault();
    e.stopImmediatePropagation();
    json('/cart.js').then(function (c) {
      var before = (c && c.item_count) || 0;
      atc.click();
      setTimeout(function () { countThenOpen(before, 0); }, 250);
    }).catch(function () { atc.click(); setTimeout(openDrawer, 900); });
  }, true);

  /* ---------------------------------------------------------------------------
     Lock the gift line inside the cart drawer.

     The drawer (assets/dab-fixes.js) renders every line with a −/+ stepper and
     a Remove link. The free tester is not the customer's to change, so we strip
     those, flatten the price to "Free", de-link it, and badge it — matching how
     the /cart page renders it. Done here by observation rather than editing the
     drawer's own renderer, which rebuilds its markup on every cart change.
  --------------------------------------------------------------------------- */
  var GIFT_KEY = String(GIFT_VARIANT) + ':';

  function lockGiftLines(root) {
    var lines = (root || document).querySelectorAll('#dab-cart .dab-cart__line');
    for (var i = 0; i < lines.length; i++) {
      var ln = lines[i];
      if (ln.getAttribute('data-dabgift')) continue;
      var key = ln.getAttribute('data-key') || '';
      if (key.indexOf(GIFT_KEY) !== 0) continue;
      ln.setAttribute('data-dabgift', '1');
      ln.classList.add('dab-cart__line--gift');
      var qty = ln.querySelector('.dab-cart__qty');
      if (qty) qty.parentNode.removeChild(qty);
      var rm = ln.querySelector('.dab-cart__rm');
      if (rm) rm.parentNode.removeChild(rm);
      var qrow = ln.querySelector('.dab-cart__qrow');
      if (qrow) qrow.innerHTML = '<span class="dab-gift-badge">Free gift</span>';
      var price = ln.querySelector('.dab-cart__price');
      if (price) price.textContent = 'Free';
      /* no product page for the gift — the scent stays a surprise */
      var links = ln.querySelectorAll('a.dab-cart__media,a.dab-cart__name');
      for (var j = 0; j < links.length; j++) links[j].removeAttribute('href');
    }
  }

  function giftStyle() {
    if (document.getElementById('dab-gift-css')) return;
    var st = document.createElement('style');
    st.id = 'dab-gift-css';
    st.textContent = '#dab-cart .dab-cart__line--gift a{cursor:default;pointer-events:none}'
      + '#dab-cart .dab-gift-badge{display:inline-block;padding:3px 9px;border:1px solid rgba(201,161,90,.45);border-radius:999px;'
      + 'color:var(--gold,#C9A15A);font:600 9px/1.4 Inter,system-ui,sans-serif;letter-spacing:.14em;text-transform:uppercase}'
      + '#dab-cart .dab-cart__line--gift .dab-cart__price{color:var(--gold,#C9A15A)}';
    (document.head || document.documentElement).appendChild(st);
  }

  function watchDrawer() {
    giftStyle();
    lockGiftLines();
    var mo = new MutationObserver(function () { lockGiftLines(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();
})();
